/* IMPORT */
import { isFunction } from '../utils.js';
export function deepResolve(value) {
    if (isFunction(value)) {
        return deepResolve(value());
    }
    if (value instanceof Array) {
        const resolved = new Array(value.length);
        for (let i = 0, l = resolved.length; i < l; i++) {
            resolved[i] = deepResolve(value[i]);
        }
        return resolved;
    }
    else {
        return value;
    }
}
